/**
 * The part of the screen the phone is actually showing.
 *
 * Owner, 16 Sep 2026: "98 percent people will use it phone and phone ui and
 * view is far from perfect i see many glitches and some thing are not visible
 * on the phone view which are visible on the desktop".
 *
 * `position: fixed` and `100dvh` both measure the LAYOUT viewport, which does
 * not shrink when the software keyboard opens. So a drawer whose footer is
 * pinned to the bottom pins it underneath the keyboard: the counter taps the
 * customer's name, the keyboard comes up, and the button they need is gone.
 * That is the shape of the Sitapur sale that never left the phone.
 *
 * The visual viewport is the honest measure, and it is the only one that moves
 * with the keyboard on both iOS and Android. This publishes it as CSS custom
 * properties so layout can use it without every component subscribing:
 *
 *   --app-vh      the visible height, in px
 *   --app-vtop    how far the visible part is pushed down (iOS scrolls the
 *                 page behind the keyboard rather than resizing)
 *
 * Installed once at start-up. On a desktop browser these equal the window and
 * nothing changes.
 */

let installed = false;

export function installViewportVars(): void {
  if (installed || typeof window === 'undefined') return;
  installed = true;

  const root = document.documentElement;
  const vv = window.visualViewport;

  const apply = () => {
    const height = vv?.height ?? window.innerHeight;
    const top = vv?.offsetTop ?? 0;
    root.style.setProperty('--app-vh', `${Math.round(height)}px`);
    root.style.setProperty('--app-vtop', `${Math.round(top)}px`);
    // A coarse "the keyboard is up" flag, for anything that wants to shed
    // chrome while someone is typing. 120px of lost height is a keyboard and
    // not a URL bar collapsing.
    const shrunk = vv ? window.innerHeight - vv.height > 120 : false;
    root.toggleAttribute('data-keyboard', shrunk);
  };

  apply();
  if (vv) {
    vv.addEventListener('resize', apply);
    vv.addEventListener('scroll', apply);
  }
  window.addEventListener('orientationchange', apply);
  window.addEventListener('resize', apply);
}
